import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { DateRangeState, DateRootState } from './date-interface';

export const DATE_FEATURE_KEY = 'DateStateData';

export interface DateState {
  appliedDateRange: DateRangeState;
}

export const initialDateState: DateState = {
  appliedDateRange: {
    key: 'selection',
    startDate: moment().startOf('day').toDate(),
    endDate: moment().startOf('day').toDate(),
  },
};

export const dateStateSlice = createSlice({
  name: DATE_FEATURE_KEY,
  initialState: initialDateState,
  reducers: {
    updateAppliedDateRange(state, action: PayloadAction<DateRangeState>) {
      state.appliedDateRange = action.payload;
    },
  },
});

export const dateStateReducer = dateStateSlice.reducer;

export const { updateAppliedDateRange } = dateStateSlice.actions;

export const getDateStatesSliceState = (rootState: DateRootState): DateState =>
  rootState[DATE_FEATURE_KEY];

export const getAppliedDateRange = createSelector(
  getDateStatesSliceState,
  (state) => state.appliedDateRange
);
